import React from "react";
import { Badge, Divider, Popover } from "antd";
import { formatLastModified } from "../utils/TimeConvert";

const NotificationPopover = ({
  notifications,
  badgeStatus = "Warning",
  overflowCount = 10,
}) => {
  console.log({ notifications });
  return (
    <div className="flex justify-end">
      <Popover
        content={
          <div className="overflow-y-auto py-2 max-h-[300px] w-[300px]">
            <ul>
              {notifications?.map((val, index) => (
                <li
                  key={index}
                  className="cursor-pointer text-black hover:bg-slate-100"
                >
                  <div className="">
                    <p className="flex text-[10px] justify-end content-end text-gray-400">
                      {formatLastModified(val?.CreatedAt)}
                    </p>
                    <p className="flex text-[10px] justify-end content-end text-gray-600">
                      Requested Document by {val.SmeId.split("#")[0]}
                    </p>
                    <p>{val?.Description}</p>
                  </div>
                  <Divider />
                </li>
              ))}
            </ul>
          </div>
        }
      >
        <Badge
          count={notifications?.length}
          overflowCount={overflowCount}
          status={badgeStatus}
        />
      </Popover>
    </div>
  );
};

export default NotificationPopover;
